export default __webpack_public_path__ + "static/media/drop_down_arrow_down.5b23ff6e.svg";